import { render, staticRenderFns } from "./PrescriptionTableCart.vue?vue&type=template&id=3b463582&scoped=true"
import script from "./PrescriptionTableCart.vue?vue&type=script&lang=js"
export * from "./PrescriptionTableCart.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionTableCart.vue?vue&type=style&index=0&id=3b463582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b463582",
  null
  
)

export default component.exports